var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoLlamadaContacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 32.4583C21.0833 44.25 30.75 53.875 42.5417 59.9167L51.7083 50.75C52.8333 49.625 54.5 49.25 55.9583 49.75C60.625 51.2917 65.6667 52.125 70.8333 52.125C73.125 52.125 75 54 75 56.2917V70.8333C75 73.125 73.125 75 70.8333 75C31.7083 75 0 43.2917 0 4.16667C0 1.875 1.875 0 4.16667 0H18.75C21.0417 0 22.9167 1.875 22.9167 4.16667C22.9167 9.375 23.75 14.375 25.2917 19.0417C25.75 20.5 25.4167 22.125 24.25 23.2917L15.0833 32.4583Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLlamadaContacto);
export default __webpack_public_path__ + "static/media/icono_llamada_contacto.ac3811b9c08ed5c8ea0179ddd228cb3e.svg";
export { ForwardRef as ReactComponent };